module.exports = __webpack_public_path__ + "img/casting2.6eafd04c.jpg";